module.exports = __webpack_public_path__ + "img/blue-add.3a2ef8be.svg";